import { Container, Grid, Typography, Box, } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import Eventback from '../../../Component/Eventback'
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';


export default function MENAInsurtech() {


    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);


    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title>DPA at MENA Insurtech Summit 2025 | AI in Insurance Innovation</title>
                <meta name="description" content="Decimal Point Analytics joined MENA Insurtech Summit 2025 in Dubai. CEO Shailesh Dhuri shared insights on AI’s impact on underwriting and risk management." />
                <meta name="author" content="Decimal Point Analytics" />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/mena-insurtech-summit-2025" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>



            <Box id='event-details' className='section sec_bg' component='section'>

                <Container maxWidth='lg' className='bdr'>

                    <Grid container spacing={1} alignItems="top" justifyContent='center'>
                        <Grid item lg={9} md={9} sm={12} xs={12}>
                            <Box>
                                <Typography variant='h2' className='subhead skblue al_center'>
                                    Events
                                </Typography>
                                <Typography variant='h1' className='mainhead blue al_center'>
                                    Decimal Point Analytics <span className='lower'>at</span> MENA Insurtech Summit 2025
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>


                    <Box className='whitebx'>
                        <Typography variant='h6' className='black jst'>
                            <strong>Decimal Point Analytics</strong> participated in the prestigious MENA Insurtech Summit 2025, held in Dubai. The event brought together global leaders in insurance and technology to discuss the future of digital transformation in the sector.
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            Representing DPA were:
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            <ul>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        <strong>Shailesh Dhuri, Chief Executive Officer</strong>
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        <strong>Vaibhav Poonekar, CTO</strong>
                                    </Typography>
                                </li>
                                <li>
                                    <Typography variant='h6' className='black jst'>
                                        <strong>Amitava Deb, Vertical Head - Insurance</strong>
                                    </Typography>
                                </li>
                            </ul>
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            Our CEO, Shailesh Dhuri, was invited to speak as a panelist, contributing insights on the evolving role of AI and data analytics in reshaping underwriting, compliance, and risk management within the insurance domain.
                        </Typography>

                        <Typography variant='h6' className='black jst'>
                            Our team engaged with innovators, insurers, and technology partners across the MENA region, fostering discussions around intelligent automation and strategic data management for the industry.
                        </Typography>

                    </Box>

                    <Eventback />

                </Container >

            </Box >

        </>
    );
}
